import constants from './constants';

// Few images are saved in jpg format
export const getImageFormat = (entType, key) => {
  if (
    (entType === 'player' && (key === 'photo_thumbnail' || key === 'photo_full' || key === 'national_photo_thumbnail' || key === 'national_photo_full')) ||
    (entType === 'manager' && (key === 'photo_thumbnail' || key === 'photo_full')) ||
    (entType === 'team' && key === 'background_full')
  ) {
    return 'jpg';
  }
  return 'png';
};

export const getImageUrl = (entityType, entityId, imgKey) => {
  const entityImages = constants.images[entityType];
  const imageConfig = entityImages && entityImages[imgKey];

  if (!imageConfig) {
    // Unknown entity/image key combination (e.g. referee, manager-flag_thumbnail).
    // Fall back to the placeholder URL rather than crashing the render.
    return constants.images.fallback_url;
  }

  const imgFormat = getImageFormat(entityType, imgKey);
  return `${constants.images.image_base_url}${imageConfig.urlKey}${entityId}.${imgFormat}`;
};

export const getFallbackImageUrl = () => constants.images.fallback_url;
